import React from "react";
import CADndItem from "./CADndItem";
import BaseSchedulesMenu from "./BaseSchedulesMenu";

const CASchedulesMenu = ({
  schedules,
  allSchedules,
  isFetching,
  onAddSchedule,
  onOpenSchedule,
  moveSchedule,
  reorderSchedule,
  searchMode = false,
}) => (
  <BaseSchedulesMenu
    schedules={schedules}
    allSchedules={allSchedules}
    isFetching={isFetching}
    onAddSchedule={onAddSchedule}
    onOpenSchedule={onOpenSchedule}
    moveSchedule={moveSchedule}
    reorderSchedule={reorderSchedule}
    searchMode={searchMode}
    DndItemComponent={CADndItem}
    buttonProps={{
      py: 1.2,
    }}
  />
);

export default CASchedulesMenu;
